import { ValidatorFn } from '@angular/forms';
import { DataTypes } from '../enums/DataType';
import { ControlBase } from './ControlBase';
export abstract class IColumns extends ControlBase {
  DomID: string | undefined;
  Validators?: ValidatorFn | null | Array<ValidatorFn>;
  Name!: string;
  DisplayName!: string;
  DataType: any;
  IsEditable: boolean=false;
  IsFilterable: boolean=false;
  IsNumber2Boolean?:Boolean;
  DefaultValue?: string | number | null | Date | boolean;
  controlType?: string;
  viewCellStyle?: string;
  ConditionalCellStyleFn?: Function;
  IsVisible: boolean=false;
  Width?: number;
  Route?:string;
  ModalTitle?: string;
  ClickableText?: string;
  LogImageTemplate?: {
    filterList: { image: string, showOnValue: number, text?:string }[];
  };
  imgs?: { image: string, showOnValue: number,text?:string }[]
  lookupTemplate?: {
    Key: string | undefined;
    ID: string | undefined;
    Description?: string;
    AfterLoad?: Function;
    BeforeLoad?: Function;
    OnClose?: Function;
    OnOpen?: Function;
    OnOpenSecondLkp?: Function;
    ReturnedValueEmitter?: Function;
    DataSource: any;
    hasSecondLkp?: boolean;
    validateCheckExistence?: boolean;
    route?:string;
    Title?:string;
    hasSelection?: boolean;
  };
  dropDownTemplate?: {
    value: string;
    text: string;
    HasStatuesIcon?: boolean;
    list: any[];
    SuggestedList?: any[];
    OnValueChange?: Function;
    OnselectionChange?: Function;
    OnOpen?:Function;
    OnFocus?:Function;
  }
  checkboxTemplate?: {
    HasSelectAll: boolean | undefined
    HasSelectAllLabel?: boolean | undefined
  };
  removeNegativeTransform?: boolean;
  Precision?:number;
  IsHiddenByUser?:boolean;
  Order?:number;
  DataBaseId?:number;
}
